module.exports = __webpack_public_path__ + "static/media/Delivery.0e12835d.svg";